module.exports = __webpack_public_path__ + "media/Mulia_Video_Highlight_Draft_1.0.b36127a8.mp4";